import { makeStyles, theme } from "cdh-data-portal-theme"
import { SIDEBAR_WIDTH } from "../../molecules/Sidebar/Sidebar.static"

export const useStyles = makeStyles()(() => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.colors.globalBackgroundLight,
    paddingTop: 89,
    paddingLeft: 42,
    paddingRight: 42,
    paddingBottom: 42,
    marginLeft: SIDEBAR_WIDTH,
  },
  title: {
    "&&": {
      fontSize: 42,
      fontWeight: 450,
      lineHeight: "68px",
      margin: 0,
    },
  },
  subtitle: {
    "&&": {
      fontSize: 26,
      fontWeight: 400,
      lineHeight: "42px",
      margin: "4px 0 0 0",
    },
  },
  cards: {
    display: "flex",
    gap: 16,
    marginTop: 26,
  },
  expandableSection: {
    background: 'white',
    borderRadius: 8,
    boxShadow: theme.shadows.medium,
    marginTop: 16,
    padding: 16,
  },
  resourceRow: {
    alignItems: "center",
    borderBottom: `1px solid ${theme.colors.globalBackgroundDark}`,
    borderRadius: 4,
    color: "inherit",
    cursor: "pointer",
    display: "flex",
    gap: 13,
    padding: "8px 5px",
    textDecoration: "none",
    transition: theme.transitions.easeOutFast,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  resourceContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 2,
    padding: 4
  },
  resourceDescription: {
    "&&": {
      fontSize: 14,
      fontWeight: 400,
      paddingLeft: 8,
    },
  },
  resourceLinkTitle: {
    "&&": {
      fontSize: 17,
      fontWeight: 600,
      lineHeight: "26px",
    },
  },
}))
